import { render, staticRenderFns } from "./BaseTwoWaySticky.vue?vue&type=template&id=15bc4c28&lang=pug&"
import script from "./BaseTwoWaySticky.vue?vue&type=script&lang=js&"
export * from "./BaseTwoWaySticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports